import {
  MenuDivider,
  MenuDividerProps,
  MenuGroup,
  MenuGroupProps,
  MenuItem,
  MenuItemProps,
} from '@chakra-ui/react';
import type { FC, ReactNode } from 'react';
export type QMenuItemProps = MenuItemProps & {
  isDestructive?: boolean;
  children?: ReactNode;
};

export const QMenuItem: FC<QMenuItemProps> = (props) => {
  const { isDestructive, children, ...rest } = props;
  return (
    <MenuItem color={isDestructive ? 'red.500' : 'inherit'} {...rest}>
      {children}
    </MenuItem>
  );
};

export interface QMenuGroupProps extends MenuGroupProps {
  title: string;
  children?: ReactNode;
}

export const QMenuGroup: FC<QMenuGroupProps> = (props) => {
  const { children, title, ...rest } = props;
  return (
    <MenuGroup {...rest} title={title}>
      {children}
    </MenuGroup>
  );
};

export type QMenuDividerProps = MenuDividerProps;

export const QMenuDivider: FC<QMenuDividerProps> = (props) => {
  return <MenuDivider {...props} />;
};
